import { useState, useCallback } from 'react';
import { cargarPaginasUltraOptimizado } from '../../../../providers/provider_paginado';
import { paginadoRecorridosStore } from '../../../../lib/store/paginador_store';
import { normalizarFiltros } from '../../../../utils/useReporteCalculations';

export const usePaginadorApagadosEncendidos = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);

  const resetPaginador = useCallback(() => {
    paginadoRecorridosStore.getState().reiniciar();
    setIsLoading(false);
    setProgress(0);
    setError(null);
  }, []);

  const cargarPaginasUltraOptimizado_Custom = useCallback(async (parametros) => {
    try {
      setIsLoading(true);
      setProgress(0);
      setError(null);
      
      console.log('📡 [HOOK] Parámetros recibidos para carga de datos:');
      console.log('   🔧 Parametros originales:', parametros);

      // Normalizar filtros y agregar tipos específicos
      const filtrosBase = normalizarFiltros(parametros);
      
      // 📊 LOG 1: VEHÍCULOS RECIBIDOS EN EL HOOK
      console.log('🎯 [HOOK] === ANÁLISIS DE VEHÍCULOS EN EL HOOK ===');
      console.log('🎯 [HOOK] 1. Vehículos recibidos en filtrosBase.uids_vehiculo:', (filtrosBase.uids_vehiculo || []).length);
      console.log('🎯 [HOOK] 1.1 Contenido filtrosBase.uids_vehiculo:', filtrosBase.uids_vehiculo);
      console.log('🎯 [HOOK] 1.2 Tipo de datos recibidos:', typeof (filtrosBase.uids_vehiculo || [])[0]);
      
      // ✅ LIMPIAR Y VALIDAR UIDS DE VEHÍCULOS - PASO A PASO
      const uids_originales = filtrosBase.uids_vehiculo || [];
      console.log('🔧 [HOOK] 2. ANTES de limpieza - Total UIDs originales:', uids_originales.length);
      
      const step1_basic_filter = uids_originales.filter(uid => uid && uid !== null && uid !== undefined && uid !== '');
      console.log('🔧 [HOOK] 2.1 DESPUÉS filtro básico (no null/undefined/empty):', step1_basic_filter.length);
      console.log('🔧 [HOOK] 2.2 Eliminados en filtro básico:', uids_originales.length - step1_basic_filter.length);
      const eliminados_basico = uids_originales.filter(uid => !(uid && uid !== null && uid !== undefined && uid !== ''));
      console.log('🔧 [HOOK] 2.3 UIDs eliminados en filtro básico:', eliminados_basico);
      
      const step2_string_conversion = step1_basic_filter.map(uid => String(uid).trim());
      console.log('🔧 [HOOK] 2.4 DESPUÉS conversión a string y trim:', step2_string_conversion.length);
      
      const vehiculosLimpios = step2_string_conversion.filter(uid => uid.length > 0);
      console.log('🔧 [HOOK] 2.5 DESPUÉS filtro final (length > 0):', vehiculosLimpios.length);
      console.log('🔧 [HOOK] 2.6 Eliminados en filtro final:', step2_string_conversion.length - vehiculosLimpios.length);
      const eliminados_finales = step2_string_conversion.filter(uid => uid.length === 0);
      console.log('🔧 [HOOK] 2.7 UIDs eliminados en filtro final (strings vacíos):', eliminados_finales);
      
      console.log('🚗 [HOOK] === RESULTADO FINAL DE LIMPIEZA ===');
      console.log('🚗 [HOOK] Vehículos después de limpieza:', vehiculosLimpios.length);
      console.log('🚗 [HOOK] UIDs finales que se usarán:', vehiculosLimpios);
      console.log('🚗 [HOOK] RESUMEN: Originales =>', uids_originales.length, '| Finales =>', vehiculosLimpios.length, '| Perdidos =>', uids_originales.length - vehiculosLimpios.length);
      
      if (vehiculosLimpios.length === 0) {
        throw new Error('No hay vehículos válidos seleccionados');
      }
      
      const filtrosFormateados = {
        ...filtrosBase,
        uids_vehiculo: vehiculosLimpios,
        tipos: filtrosBase.tipos || [3, 4, 5, 6] // Eventos de apagado (3,5) y encendido (4,6)
      };
      
      console.log('📡 [HOOK] Filtros formateados finales que se enviarán a la API:');
      console.log('   🎯 URL endpoint:', 'vehicle-locations');
      console.log('   📅 Fecha inicio:', filtrosFormateados.fecha_inicio);
      console.log('   📅 Fecha fin:', filtrosFormateados.fecha_fin);
      console.log('   🚗 UIDs vehículos:', filtrosFormateados.uids_vehiculo);
      console.log('   🏷️ Tipos eventos:', filtrosFormateados.tipos);
      
      // ✅ MOSTRAR INFORMACIÓN DE EMPRESA SEGÚN EL TIPO DE REPORTE
      if (filtrosFormateados.es_reporte_multi_empresa) {
        console.log('   👑 [REPORTE ADMINISTRADOR] Empresas seleccionadas:', filtrosFormateados.empresas_seleccionadas);
        console.log('   🏢 Empresa del usuario (fallback):', filtrosFormateados.empresaUid);
      } else {
        console.log('   🏢 [REPORTE NORMAL] Empresa UID:', filtrosFormateados.empresaUid);
      }
      
      console.log('   👤 Usuario UID:', filtrosFormateados.uid_usuario);
      console.log('   🔑 Perfil:', filtrosFormateados.perfil);
      console.log('   📊 Es multi-empresa:', filtrosFormateados.es_reporte_multi_empresa ? 'SÍ' : 'NO');

      // Usar el paginador de recorridos existente 
      const paginador = paginadoRecorridosStore.getState();
      
      // Reiniciar el paginador
      paginador.reiniciar();
      // URL del API
      const apiUrl = process.env.REACT_APP_VEHICLE_LOCATIONS_URL;
      
      // ID de conexión único
      const connectionId = 'apagados-encendidos';
      
      // Callback para actualizar el progreso
      const onMetricsUpdate = (updates) => {
        if (updates.downloadProgress) {
          setProgress(updates.downloadProgress);
        }
      };

      // Llamar a la función optimizada
      await cargarPaginasUltraOptimizado(
        apiUrl,
        paginador,
        filtrosFormateados,
        connectionId,
        null,
        onMetricsUpdate
      );

      // Obtener los datos finales
      const estadoFinal = paginadoRecorridosStore.getState();
      
      console.log(`✅ Datos recibidos: ${estadoFinal.datos.length} eventos`);
      
      setIsLoading(false);
      setProgress(100);
      
      return estadoFinal.datos;

    } catch (error) {
      console.error('❌ Error cargando datos:', error);
      setError(error.message || 'Error desconocido');
      setIsLoading(false);
      setProgress(0);
      throw error;
    }
  }, []);

  // Usar el store directamente para obtener datos reactivos
  const datos = paginadoRecorridosStore((state) => state.datos);
  const totalPaginas = paginadoRecorridosStore((state) => state.totalPaginas);
  const paginaActual = paginadoRecorridosStore((state) => state.paginaActual);

  // Objeto que simula la interfaz original para compatibilidad
  const paginadorApagadosEncendidos = {
    datos: datos,
    cargando: isLoading,
    progreso: progress,
    error: error,
    totalPaginas: totalPaginas,
    paginaActual: paginaActual
  };

  return {
    paginadorApagadosEncendidos,
    cargarPaginasUltraOptimizado: cargarPaginasUltraOptimizado_Custom,
    resetPaginador
  };
};
